import { Icon } from '@elipssolution/harfang';
import { mdiChevronRight } from '@mdi/js';
import { styled } from '@mui/material';

const StyledIcon = styled(Icon)(({ theme: { palette } }) => ({
	display: 'block',

	color: palette.grey[500],
}));

const LinkIcon = () => <StyledIcon path={mdiChevronRight} />;

export default LinkIcon;
